import { TAccount } from './accounts.types';

type TAccountHasPendingPayout =
    | { hasPendingPayout: true; pendingPayoutAmount: number }
    | { hasPendingPayout: false; pendingPayoutAmount: null };

export const getAccountHasPendingPayout = (
    account: TAccount
): TAccountHasPendingPayout => {
    if (account.has_pending_payout) {
        return {
            hasPendingPayout: true,
            // has_pending_payout checks if there is an initiated payment instruction, which always has an amount
            pendingPayoutAmount: account.pending_payout_amount!
        };
    }

    return {
        hasPendingPayout: false,
        pendingPayoutAmount: null
    };
};
